import Hbox from './hbox';
import Vbox from './vbox';
import Main from './main';
import Primary from './primary';
import Secondary from './secondary';
import SlideSecondary from './slideSecondary';

export {
  Hbox,
  Vbox,
  Primary,
  Secondary,
  SlideSecondary,
};

export default Main;
